export default __webpack_public_path__ + "static/media/working07.6612c262.png";